'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M18.6665 0H28V20H18.6665V0Z", fill: "#63AEE3" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H9.33333V0H0V20Z",
          fill: "#63AEE3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3335 8.66665C11.7017 8.66665 12.0002 8.96512 12.0002 9.33331C12.0002 10.0718 12.4001 10.7177 12.9984 11.0648C13.3168 11.2496 13.4252 11.6576 13.2404 11.976C13.0556 12.2945 12.6477 12.4029 12.3292 12.2181C11.3367 11.6422 10.6668 10.5664 10.6668 9.33331C10.6668 8.96512 10.9653 8.66665 11.3335 8.66665ZM16.6668 8.66665C17.035 8.66665 17.3335 8.96512 17.3335 9.33331C17.3335 10.5147 16.7184 11.552 15.7942 12.1431C15.484 12.3414 15.0718 12.2508 14.8734 11.9406C14.675 11.6305 14.7656 11.2182 15.0758 11.0198C15.6331 10.6634 16.0002 10.041 16.0002 9.33331C16.0002 8.96512 16.2986 8.66665 16.6668 8.66665Z",
          fill: "#628A40"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9998 10.6667C14.7362 10.6667 15.3332 10.0697 15.3332 9.33333C15.3332 8.59695 14.7362 8 13.9998 8C13.2635 8 12.6665 8.59695 12.6665 9.33333C12.6665 10.0697 13.2635 10.6667 13.9998 10.6667Z",
          fill: "#DCC26D"
        }
      )
    ]
  }
);
const VpFlagGtAsset = forwardRef(FlagGtAsset);

export { VpFlagGtAsset as default };
